import React from 'react';
import { Home, BarChart2, Calendar, Settings, BellRing, Users, MessageSquare, LogOut } from 'lucide-react';
export function Sidebar() {
  return <aside className="w-full lg:w-64 bg-white border-r lg:min-h-screen" data-id="element-210">
      <div className="p-4 border-b" data-id="element-211">
        <h1 className="text-xl font-bold" data-id="element-212">SocialDash</h1>
      </div>
      <nav className="p-4" data-id="element-213">
        <ul className="space-y-1" data-id="element-214">
          <li data-id="element-215">
            <a href="#" className="flex items-center gap-3 px-4 py-2 bg-blue-50 text-blue-600 rounded-md" data-id="element-216">
              <Home size={18} data-id="element-217" />
              <span data-id="element-218">there</span>
            </a>
          </li>
          <li data-id="element-219">
            <a href="#" className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-220">
              <BarChart2 size={18} data-id="element-221" />
              <span data-id="element-222">Analytics</span>
            </a>
          </li>
          <li data-id="element-223">
            <a href="#" className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-224">
              <Calendar size={18} data-id="element-225" />
              <span data-id="element-226">Content Calendar</span>
            </a>
          </li>
          <li data-id="element-227">
            <a href="#" className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-228">
              <MessageSquare size={18} data-id="element-229" />
              <span data-id="element-230">Conversations</span>
            </a>
          </li>
          <li data-id="element-231">
            <a href="#" className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-232">
              <Users size={18} data-id="element-233" />
              <span data-id="element-234">Audience</span>
            </a>
          </li>
        </ul>
      </nav>
      <div className="p-4 border-t mt-4" data-id="element-235">
        <h2 className="text-sm font-medium text-gray-500 mb-3" data-id="element-236">
          Recent Activity
        </h2>
        {/* Notifications */}
        <div className="space-y-3 mb-6" data-id="element-237">
          <div className="flex items-start gap-2" data-id="element-238">
            <div className="p-1 bg-blue-100 text-blue-600 rounded-full" data-id="element-239">
              <BellRing size={14} data-id="element-240" />
            </div>
            <div className="text-sm" data-id="element-241">
              <p className="text-gray-800" data-id="element-242">3 new mentions on Twitter</p>
              <p className="text-gray-500 text-xs" data-id="element-243">10 minutes ago</p>
            </div>
          </div>
          <div className="flex items-start gap-2" data-id="element-244">
            <div className="p-1 bg-green-100 text-green-600 rounded-full" data-id="element-245">
              <Users size={14} data-id="element-246" />
            </div>
            <div className="text-sm" data-id="element-247">
              <p className="text-gray-800" data-id="element-248">New follower milestone reached</p>
              <p className="text-gray-500 text-xs" data-id="element-249">1 hour ago</p>
            </div>
          </div>
        </div>
        {/* Scheduled Posts */}
        <div className="mb-6" data-id="element-250">
          <h2 className="text-sm font-medium text-gray-500 mb-3" data-id="element-251">
            Scheduled Posts
          </h2>
          <div className="space-y-2" data-id="element-252">
            <div className="p-2 bg-gray-50 rounded-md" data-id="element-253">
              <p className="text-xs font-medium" data-id="element-254">Tomorrow, 9:00 AM</p>
              <p className="text-sm truncate" data-id="element-255">
                Weekly product update announcement
              </p>
            </div>
            <div className="p-2 bg-gray-50 rounded-md" data-id="element-256">
              <p className="text-xs font-medium" data-id="element-257">Wednesday, 3:30 PM</p>
              <p className="text-sm truncate" data-id="element-258">
                Customer spotlight: Success story
              </p>
            </div>
            <div className="p-2 bg-gray-50 rounded-md" data-id="element-259">
              <p className="text-xs font-medium" data-id="element-260">Friday, 12:00 PM</p>
              <p className="text-sm truncate" data-id="element-261">Weekend special promotion</p>
            </div>
          </div>
        </div>
        {/* Quick Stats */}
        <div className="bg-gray-50 p-3 rounded-lg" data-id="element-262">
          <h2 className="text-sm font-medium mb-2" data-id="element-263">Today's Quick Stats</h2>
          <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-264">
            <div data-id="element-265">
              <p className="text-gray-500 text-xs" data-id="element-266">New Followers</p>
              <p className="font-medium" data-id="element-267">+47</p>
            </div>
            <div data-id="element-268">
              <p className="text-gray-500 text-xs" data-id="element-269">Impressions</p>
              <p className="font-medium" data-id="element-270">234</p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 border-t mt-auto" data-id="element-271">
        <button className="flex items-center gap-2 text-gray-700 hover:text-gray-900" data-id="element-272">
          <Settings size={18} data-id="element-273" />
          <span data-id="element-274">Settings</span>
        </button>
        <button className="flex items-center gap-2 text-gray-700 hover:text-gray-900 mt-4" data-id="element-275">
          <LogOut size={18} data-id="element-276" />
          <span data-id="element-277">Login</span>
        </button>
      </div>
    </aside>;
}